import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default {
	init() {
		const sliders = document.querySelectorAll('.layout.logo-slider .logo-slider-swiper');
		if (!sliders.length) return;

		sliders.forEach((sliderEl) => {
			const paginationEl = sliderEl.querySelector('.swiper-pagination');
			const nextEl = sliderEl.querySelector('.swiper-button-next');
			const prevEl = sliderEl.querySelector('.swiper-button-prev');
			let pagination;
			if (paginationEl) {
				pagination = {
					el: paginationEl,
					type: 'progressbar',
				};
			}
			const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

			new Swiper(sliderEl, {
				modules: [Navigation, Pagination],
				slidesPerView: 4,
				spaceBetween: 28,
				grabCursor: true,
				watchOverflow: true,
				observer: true,
				observeParents: true,
				pagination,
				navigation,
				breakpoints: {
					0: { slidesPerView: 1 },
					481: { slidesPerView: 2 },
					641: { slidesPerView: 3 },
					769: { slidesPerView: 4 },
				},
			});
		});
	},
};
